package org.example.project.enginevertrieb

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.*
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.example.project.utils.All
import org.w3c.fetch.RequestInit

internal object LinkedInDmApi {
    private val json = Json { ignoreUnknownKeys = true; encodeDefaults = true }
    private suspend fun request(action: String, body: String? = null): String {
        val response = window.fetch("${LumaticaApiSettings.getBaseUrl()}/api/linkedinflow/$action", RequestInit(
            method = if (body == null) "GET" else "POST", headers = LumaticaApiManager.auditHeaders("application/json"), body = body
        )).await()
        val raw = response.text().await()
        if (!response.ok) error(runCatching { json.parseToJsonElement(raw).jsonObject["message"]?.jsonPrimitive?.contentOrNull }.getOrNull() ?: "DM-Einstellungen: HTTP ${response.status}")
        return raw
    }
    suspend fun index(): List<All> = json.decodeFromString(ListSerializer(All.serializer()), request("dm-index"))
    suspend fun saveEntries(entries: List<All>): List<All> = json.decodeFromString(ListSerializer(All.serializer()),
        request("dm-index-save", json.encodeToString(All.serializer(), All(linkedinDmEintraege = entries))))
    suspend fun deleteEntries(ids: Set<String>): List<All> = json.decodeFromString(ListSerializer(All.serializer()),
        request("dm-index-delete", json.encodeToString(All.serializer(), All(ids = ids.toList()))))
}
